import { Stack } from '@mui/material';
import { AutoComplete, SelectBox } from '../../components/FormComponents';

function CustomObjectAction(props) {
  const {
    dropDown,
    selectedFilters,
    handleFilterChange,
  } = props;

  return (
    <Stack
      width={{
        xs: '100%', sm: '80%', md: '70%', lg: '50%',
      }}
      direction={{ xs: 'column', sm: 'row' }}
      alignItems="center"
      gap={1}
    >
      <AutoComplete
        label="Account"
        options={dropDown.accountMenuList}
        value={selectedFilters.account}
        onChange={(e, newVal) => handleFilterChange('account', newVal)}
        isOptionEqualToValue={(option, value) => option.value === value.value}
      />

      <SelectBox
        name="timeFrame"
        title="Time Frame"
        data={dropDown.timeFrame}
        value={selectedFilters.timeFrame}
        onChange={(e) => handleFilterChange('timeFrame', e.target.value)}
      />
    </Stack>
  );
}

export default CustomObjectAction;
